/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/return-await */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import type { FChallenge, IChallenge, galleriesSort } from 'garden-common';
import { slugify } from 'garden-utils/index';
import { api } from './index'

export const findChallenges = async (options: {
  limit: number;
  page: number;
  sort: (typeof galleriesSort)[number]; // same as galleries
}): Promise<FChallenge[]> => {
  return await api
    .get(`/challenges?limit=${options.limit}&page=${options.page}&sort=${options.sort}`)
    .then(res => {
      return res.data.challenges;
    });
};

export const findChallenge = async (title: FChallenge['challengeTitle']): Promise<FChallenge> => {
  return await api.get(`/challenges/${slugify(title)}`).then(res => {
    return res.data.challenge;
  });
};

export const findActiveChallenge = async (): Promise<FChallenge> => {
  return await api.get(`/challenges/show/active`).then(res => {
    return res.data.challenge;
  });
};

export const updateChallenge = async (
  id: FChallenge['_id'],
  data: {
    challengeTitle?: FChallenge['challengeTitle'];
    challengeDescription?: FChallenge['challengeDescription'];
    coverImageUrl?: FChallenge['coverImageUrl'];
    collaborators?: IChallenge<string>['collaborators'];
    startTime?: FChallenge['startTime'];
    endTime?: FChallenge['endTime'];
  }
) => {
  return await api.put(`/challenges/${id}`, data).then(res => {
    return res.data.challenge;
  });
};

export const createChallenge = async (obj: {
  challengeTitle: FChallenge['challengeTitle'];
  challengeDescription: FChallenge['challengeDescription'];
  challengeCreator: FChallenge['challengeCreator']['_id'];
  startTime: FChallenge['startTime'];
  endTime: FChallenge['endTime'];
}): Promise<FChallenge> => {
  return await api
    .post(`/challenges/create`, obj)
    .then(res => {
      return res.data.challenge;
    })
    .catch(err => {
      console.error(err);
    });
};
